import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Button, Copy, themeColor } from '@elparking/components'

import {
    height,
} from 'commons/js/theme/styles'

const Container = styled.div`
    position: relative;
    width: 100%;
    ${height}
    overflow: hidden;
    transition: height 2s;
`

Container.defaultProps = {
    h: 'auto',
}

const ButtonContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    background: ${themeColor('white')};
    padding-left: 0.2em;
    padding-top: 0.2em;
`

class OverflowBlox extends React.Component {
    static propTypes = {
        children: PropTypes.element,
        height: PropTypes.any,
        active: PropTypes.bool,
    }

    state = {
        open: false,
    }

    render () {
        const { active, height, children } = this.props
        const { open } = this.state

        if (!active) {
            return <span>
                {children}
            </span>
        }

        if (open) {
            return <Container>
                {children}
                <Copy padding='0' textAlign='right'>
                    <Button.unstyled fontSize='xSmall' onClick={() => this.setState({open: false})}>
                        <FormattedMessage defaultMessage='Ver menos' />
                    </Button.unstyled>
                </Copy>
            </Container>
        }

        return (
            <Container height={height}>
                {children}
                <ButtonContainer>
                    <Button.unstyled fontSize='xSmall' onClick={() => this.setState({open: true})}>
                        ...<FormattedMessage defaultMessage='Ver más' />
                    </Button.unstyled>
                </ButtonContainer>
            </Container>
        )
    }
}

export default OverflowBlox
